<template>

    <div class="animated fadeIn" v-if="headquarters && headquarters.length > 0">
        <b-row class="py-2" >
            <b-card header="Editar Convenio" class="w-100">
                <b-form @submit.prevent="store" enctype="multipart/form-data">
                    <b-row>
                        <b-col sm="12" md="12" lg="4">
                            <b-row class="px-3">

                                <b-form-group
                                    label="<strong>Entidad *</strong>"
                                    label-for="entity"
                                    :horizontal="false"
                                    class="w-100">
                                    <b-form-input
                                        id="entity"
                                        type="text"
                                        placeholder="Entidad"
                                        v-model="item.entity"
                                        required></b-form-input>
                                </b-form-group>

                                <b-form-group
                                    label="<strong>Nombre *</strong>"
                                    label-for="name"
                                    :horizontal="false"
                                    class="w-100">
                                    <b-form-input
                                        id="name"
                                        type="text"
                                        placeholder="Nombre Convenio"
                                        v-model="item.name"
                                        required></b-form-input>
                                </b-form-group>

                                <b-form-group
                                    label="<strong>Tipo *</strong>"
                                    label-for="type"
                                    :horizontal="false"
                                    class="w-100">
                                    <multiselect
                                        name="type"
                                        v-model="item.type"
                                        :allow-empty="false"
                                        :options="agreementTypes.map(type => type.value)"
                                        :custom-label="opt => agreementTypes.find(x => x.value == opt).name"
                                        selectLabel="+"
                                        deselectLabel="-"
                                        placeholder="Seleccione opción"></multiselect>
                                </b-form-group>

                                <b-form-group
                                    label="<strong>Cuota</strong>"
                                    label-for="feeAmount"
                                    :horizontal="false"
                                    class="w-100"
                                    v-if="isFeeAgreementType(item.type)">
                                    <b-form-input
                                        id="feeAmount"
                                        type="number"
                                        placeholder="€"
                                        v-model.number="item.feeAmount"></b-form-input>
                                </b-form-group>

                                <strong>Vigencia *</strong>
                                <b-form-group
                                    label="<small>Fecha de Inicio</small>"
                                    label-for="date"
                                    class="w-100 pt-1 mb-2">
                                    <v-date-picker
                                        v-model='date.start'
                                        class="p-0 form-control date-picker-w-100 date-picker-custom-border"
                                        popoverDirection="top"
                                        required>
                                    </v-date-picker>
                                </b-form-group>
                                <b-form-group
                                    label="<small>Fecha de Fin</small>"
                                    label-for="date"
                                    class="w-100">
                                    <v-date-picker
                                        :min-date='date.start'
                                        v-model='date.end'
                                        class="p-0 form-control date-picker-w-100 date-picker-custom-border"
                                        popoverDirection="top"
                                        required>
                                    </v-date-picker>
                                </b-form-group>

                            </b-row>
                        </b-col>

                        <b-col sm="12" md="12" lg="4">
                            <label for="description"><strong>Descripción</strong></label>
                            <b-form-textarea
                                id="description"
                                v-model="item.description"
                                placeholder="Describa el convenio"
                                :rows="5"
                                :max-rows="6">
                            </b-form-textarea>

                            <b-form-group
                                label="<strong>Documento</strong>"
                                label-for="file"
                                :horizontal="false"
                                class="w-100 pt-3">
                                <b-form-file
                                    v-model="item.file"
                                    name="file"
                                    placeholder="Seleccione un archivo..."
                                    accept="application/pdf"></b-form-file>
                                <!--<a :href="'public/uploads/'+item.file_path">Abrir</a>!-->
                            </b-form-group>

                            <b-form-group
                                label="<strong>Periodo de validez</strong>"
                                label-for="valid_period"
                                :horizontal="false"
                                class="w-100">
                                <b-form-input
                                    id="valid_period"
                                    type="number"
                                    placeholder="Número de Meses"
                                    v-model.number="item.valid_period"></b-form-input>
                            </b-form-group>

                        </b-col>
                        <b-col sm="12" md="4">
                            <b-form-group
                                label="<strong>Sedes *</strong>"
                                label-for="headquarters"
                                :label-cols="3">
                                <b-form-checkbox-group
                                    stacked
                                    id="headquarters"
                                    name="headquarters"
                                    v-model="item.headquarters"
                                    @input="notifyChange">
                                    <template v-for="headquarter in headquarters">
                                        <b-form-checkbox :value="headquarter.code">{{ headquarter.name }}</b-form-checkbox>
                                    </template>
                                </b-form-checkbox-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <div class="col float-left">
                            <button
                                type="submit"
                                class="btn btn-brand btn-primary btn-lg pull-right"
                                :disabled="isSaveButtonDisabled"
                                v-if="mixinCheckPermission('AGREEMENT_EDIT')">
                                Guardar
                            </button>
                        </div>
                    </b-row>
                </b-form>
            </b-card>
        </b-row>
    </div>
</template>

<script>
    import VueNotifications from 'vue-notifications';
    import {setupCalendar, DatePicker} from 'v-calendar';
    import 'v-calendar/lib/v-calendar.min.css';
    import Multiselect from 'vue-multiselect';
    import form from '@/helpers/form';
    import {request} from '@/helpers/services';
    import {setPropertiesWithEmptyStringToNull} from '@/helpers/objects';
    import {getAgreementTypes, isFeeAgreementType} from '@/helpers/agreement-helper';

    setupCalendar({
        firstDayOfWeek: 2, // Monday
    });

    export default {
        name: 'addAgreements',
        components: {
            Multiselect,
            'v-date-picker': DatePicker,
        },
        mounted() {
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.getGeneralCheck('headquarters', 'headquarters', 'uuid', 'name');
            this.getFeeTypes();
            this.getItem();
        },
        data: function () {
            return {
                topmenu: [
                    {
                        name: 'Volver',
                        path: '/admin/agreements/list',
                        brand: 'fa fa-arrow-left'
                    },
                ],
                item: {
                    uuid: 0,
                    entity: "",
                    name: "",
                    description: "",
                    startDate: "",
                    endDate: "",
                    feeAmount: null,
                    valid_period: null,
                    headquarters: null,
                    file: null,
                    type: 'GENERAL',
                },
                date: {
                    start: null,
                    end: null,
                },
                headquarters: null,
                feeTypes: [],
                items_url: 'agreements/',
                file: null,
            }
        },
        computed: {
            isSaveButtonDisabled() {
                return !this.item.headquarters || !this.item.headquarters.length > 0;
            },
            agreementTypes() {
                return getAgreementTypes();
            }
        },
        methods: {
            async getItem() {
                try {
                    this.$_loadingMixin_showLoading();
                    const response = await axios.get('agreement/' + this.$route.params.uuid);
                    this.$_loadingMixin_hideLoading();

                    if (response.status == "200") {
                        this.item = Object.assign({}, this.item, response.data);

                        this.item.headquarters = response.data.headquarters.map(obj => obj.uuid);
                        if (typeof response.data.fee_type !== 'undefined') {
                            this.item.feeTypeId = response.data.fee_type.uuid;
                        }

                        this.date.start = new Date(response.data.start_date);
                        this.date.end = new Date(response.data.end_date);
                    }
                } catch (error) {
                    self.showErrorMsg();
                    return error;
                }
            },
            async getFeeTypes() {
                try {
                    this.feeTypes = await request('fee/types', 'get', 200);
                } catch (error) {
                    this.showGetErrorMsg();
                    console.log(error);
                }
            },
            store() {
                let self = this;
                this.$_loadingMixin_showLoading();

                setPropertiesWithEmptyStringToNull(this.item);
                axios.post(this.items_url + this.$route.params.uuid, form.objectToFormData(this.item))
                    .then(function (response) {
                        self.$_loadingMixin_hideLoading();
                        if (response.status == "200") {
                            self.showSuccessMsg();
                            self.$router.push({path: '/admin/agreements/list'});
                        }
                    })
                    .catch(function (error) {
                        self.$_loadingMixin_hideLoading();
                        if (error.response.status == 400) {
                            self.showFormatMsg();
                        } else {
                            self.showErrorMsg();
                        }
                    });
            },
            async getGeneralCheck(url, varName, valName, textName) {
                let self = this;
                let path = url;
                let list = new Array();

                try {
                    this.$_loadingMixin_showLoading();
                    const response = await axios.get(path);
                    this.$_loadingMixin_hideLoading();

                    if (response.status == "200") {
                        response.data.forEach(function (data) {
                            data['name'] = data[textName];
                            data['code'] = data[valName];
                            list.push(data);
                        });
                        response.data.unshift({
                            name: 'Todas',
                            code: 'ALL',
                        });
                        this[varName] = response.data;
                        return list;
                    }
                } catch (error) {
                    self.showErrorMsg();
                    return error;
                }
            },
            isFeeAgreementType(agreementType) {
                return isFeeAgreementType(agreementType);
            },
            selectAllOptions() {
                const headquarters = this.headquarters.slice(1,this.headquarters.length);
                this.item.headquarters = headquarters.map(headquarter => headquarter.uuid);
            },
            notifyChange(headquarters) {
                if (!!headquarters.find(headquartersOption => (headquartersOption === 'ALL'))) {
                    this.selectAllOptions();
                }
            }
        },
        notifications: {
            showSuccessMsg: {
                type: VueNotifications.types.success,
                title: 'Operación Completada',
                message: 'Registro almacenado con éxito'
            },
            showErrorMsg: {
                type: VueNotifications.types.error,
                title: 'Operación denegada',
                message: 'Algo salió mal'
            },
            showFormatMsg: {
                type: VueNotifications.types.error,
                title: 'Operación Rechazada',
                message: 'Por favor, revise los campos'
            }
        },
        watch: {
            'date.start': function () {
                this.item.startDate = new Date(this.date.start).toLocaleDateString('zh-Hans-CN').split('/').join("-")
            },
            'date.end': function () {
                this.item.endDate = new Date(this.date.end).toLocaleDateString('zh-Hans-CN').split('/').join("-")
            }
        }
    }
</script>